export const RESOURCES_REQUEST = 'RESOURCES_REQUEST';
export const RESOURCES_SUCCESS = 'RESOURCES_SUCCESS';
export const RESOURCES_ERROR = 'RESOURCES_ERROR';

export const RESOURCES_ME_REQUEST = 'RESOURCES_ME_REQUEST';
export const RESOURCES_ME_SUCCESS = 'RESOURCES_ME_SUCCESS';
export const RESOURCES_ME_ERROR = 'RESOURCES_ME_ERROR';

export const RESOURCE_TYPE_REQUEST = 'RESOURCE_TYPE_REQUEST';
export const RESOURCE_TYPE_SUCCESS = 'RESOURCE_TYPE_SUCCESS';
export const RESOURCE_TYPE_ERROR = 'RESOURCE_TYPE_ERROR';

const block = {
  loading: true,
  success: false,
  error: null,
};

const initialState = {
  resources: [],
  resourcesMe: [],
  getResourcesMe: { ...block },
  getResources: { ...block },
  resourceTypes: { ...block, types: [] },
};

export const ResourcesReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESOURCES_REQUEST:
      return {
        ...state,
        getResources: { ...state.getResources, loading: true },
      };
    case RESOURCES_SUCCESS:
      return {
        ...state,
        getResources: {
          ...state.getResources,
          loading: false,
          success: true,
          error: null,
        },
        resources: action.list,
      };
    case RESOURCES_ERROR:
      return {
        ...state,
        getResources: {
          ...state.getResources,
          loading: false,
          error: action.error,
        },
      };
    case RESOURCES_ME_REQUEST:
      return {
        ...state,
        getResourcesMe: { ...state.getResourcesMe, loading: true },
      };
    case RESOURCES_ME_SUCCESS:
      return {
        ...state,
        getResourcesMe: {
          ...state.getResourcesMe,
          loading: false,
          success: true,
          error: null,
        },
        resourcesMe: action.list,
      };
    case RESOURCES_ME_ERROR:
      return {
        ...state,
        getResourcesMe: {
          ...state.getResourcesMe,
          loading: false,
          error: action.error,
        },
      };
    case RESOURCE_TYPE_REQUEST:
      return {
        ...state,
        resourceTypes: { ...state.resourceTypes, loading: true },
      };
    case RESOURCE_TYPE_SUCCESS:
      return {
        ...state,
        resourceTypes: {
          ...state.resourceTypes,
          loading: false,
          success: true,
          error: null,
          types: action.data,
        },
      };
    case RESOURCE_TYPE_ERROR:
      return {
        ...state,
        resourceTypes: {
          ...state.resourceTypes,
          loading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};
